<template>
  <el-tree
    :check-strictly="true"
    :data="treeData"
    node-key="id"
    :props="props"
    :highlight-current="true"
    @node-click="handleClick"
    ref="dataTree"
  >
  </el-tree>

  <!-- :check-strictly="true" -->
  <!-- :load="loadNode" -->
</template>
<script>
export default {
  name: "subconCategoryTree",
  props: {
    treeData: {
      default: [],
      type: Array,
    },
  },
  data() {
    return {
      categoryObj: {},
      props: {
        label: "name",
        children: "children",
        isLeaf: "categoryCode",
      },
    };
  },
  mounted() {},
  methods: {
    handleCheckChange(data, checked, indeterminate) {
      this.categoryObj = data;

      // if (checked) {
      //   this.$refs.dataTree.setCheckedKeys([data.id]);
      //   this.company = data;
      // }
    },
    handleClick(data, node, _slef) {
      if (node.level >= 2) {
        this.categoryObj = data;
      } else {
        this.categoryObj = null;
      }
    },
  },
};
</script>
